<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <p class="banner-title">{{ chainTitle }}</p>
      <div class="data1"><span style="color: #2AD3DA">{{ data1['price'] + '万吨' }}</span></div>
      <div class="data2"><span style="color: #2AD3DA">{{ data2['price'] }}</span></div>
      <div class="data3"><span style="color: #2AD3DA">{{ data3['price'] }}</span></div>
      <div class="data4"><span style="color: #2AD3DA">{{ data4['price'] }}</span>
      </div>
      <div class="data5"><span style="color: #2AD3DA">{{ data5['price'] }}</span>
      </div>
      <div class="data6"><span style="color: #2AD3DA">{{ data6['price'] }}</span>
      </div>
      <div class="data7"><span style="color: #2AD3DA">{{ data7['price'] }}</span>
      </div>
      <div class="data8"><span style="color: #2AD3DA">{{ data8['price'] }}</span>
      </div>
      <div class="data9"><span style="color: #2AD3DA">{{ data9['price'] }}</span>
      </div>
      <div class="data10"><span style="color: #2AD3DA">{{ data10['price'] }}</span>
      </div>
      <div class="data11"><span style="color: #2AD3DA">{{ data11['price'] }}</span>
      </div>
      <div class="data12"><span style="color: #2AD3DA">{{ data12['price'] }}</span>
      </div>
      <div class="data13"><span style="color: #2AD3DA">{{ data13['price'] }}</span>
      </div>
      <div class="data14"><span style="color: #2AD3DA">{{ data14['price'] }}</span>
      </div>
      <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
        {{ '+' + chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
      <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
        {{ '+' + chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
      <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
        {{ '+' + chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
      <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
        {{ '+' + chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
      <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
        {{ '+' + chainPrice['differPrice5'] }}
      </div>
      <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
      </div>
      <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
      <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
        {{ '+' + chainPrice['differPrice6'] }}
      </div>
      <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
      </div>
      <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'chainTitle',
    'data1',
    'data2',
    'data3',
    'data4',
    'data5',
    'data6',
    'data7',
    'data8',
    'data9',
    'data10',
    'data11',
    'data12',
    'data13',
    'data14',
    'chainPrice'
  ],
  data() {
    return {}
  },
  created() {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  height: 544px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 980px;
    height: 546px;
    display: inline-block;
    background: url("../../assets/home/jineixiananchanyelian.png");
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;

    img {
      width: 980px;
      height: 544px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 30px;
      left: 616px;
      font-size: 22px;
    }

    .data1 {
      width: 133px;
      height: 37px;
      font-size: 22px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 37px;
      position: absolute;
      top: 233px;
      left: 50px;
      text-align: center;
    }

    .data2 {
      width: 133px;
      height: 37px;
      font-size: 22px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 37px;
      position: absolute;
      top: 309px;
      left: 50px;
      text-align: center;
    }

    .data3 {
      font-size: 22px;
      width: 133px;
      position: absolute;
      top: 374px;
      left: 50px;
      text-align: center;
      height: 50px;
    }

    .data4 {
      width: 133px;
      font-size: 22px;
      position: absolute;
      top: 440px;
      left: 50px;
      text-align: center;
      height: 50px;
    }

    .data5 {
      font-size: 22px;
      position: absolute;
      top: 314px;
      left: 222px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 22px;
      position: absolute;
      top: 250px;
      left: 409px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 22px;
      position: absolute;
      top: 424px;
      left: 409px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data8 {
      font-size: 22px;
      position: absolute;
      top: 173px;
      left: 620px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data9 {
      font-size: 22px;
      position: absolute;
      top: 277px;
      left: 620px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data10 {
      font-size: 22px;
      position: absolute;
      top: 345px;
      left: 620px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data11 {
      font-size: 22px;
      position: absolute;
      top: 415px;
      left: 620px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data12 {
      font-size: 22px;
      position: absolute;
      top: 90px;
      left: 829px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data13 {
      font-size: 22px;
      position: absolute;
      top: 159px;
      left: 829px;
      width: 133px;
      height: 50px;
      text-align: center;
    }
    .data14 {

      font-size: 22px;
      position: absolute;
      top: 225px;
      left: 829px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .differPrice1 {
      font-size: 22px;
      position: absolute;
      top: 95px;
      left: 242px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      font-size: 22px;
      position: absolute;
      top: 502px;
      left: 242px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      font-size: 22px;
      position: absolute;
      top: 128px;
      left: 534px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      font-size: 22px;
      position: absolute;
      top: 230px;
      left: 534px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      font-size: 22px;
      position: absolute;
      top: 309px;
      left: 534px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      font-size: 22px;
      position: absolute;
      top: 376px;
      left: 534px;
      width: 100px;
      height: 25px;
      text-align: center;
    }
  }

  .redColor {
    color: #FF6969;
  }

  .greenColor {
    color: #43E97B;
  }
}
</style>
